// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__awJ2b","gfeWrapper":"CalendarEvent_gfeWrapper__1zO-e"};